import { RootStateType } from '../../store';

export function selectAlertState(state: RootStateType) {
  return state.alert;
}
